<template>
    <div class="lista">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="import_profiles_modal" :title="'Importar Modelos'">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Importar Perfiles</h3>
                <div class="add">
                    <label>Selecciona el archivo</label>
                    <input type="file" ref="file_profiles" name="profiles" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                    <button @click="importModels()">Agregar Nuevo</button>
                </div>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="export_profiles_modal" :title="'Importar Modelos'">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Exportar Perfiles</h3>
                <div class="add">
                    <h4 for="">Tipo</h4>
                    <div>
                        <label for="">Todas</label><input type="radio" v-model="type" id="todas" value="todas">
                        <label for="">Studio</label><input type="radio" v-model="type" id="studio" value="studio">
                        <label for="">Satelite</label><input type="radio" v-model="type" id="satelite" value="satelite">
                    </div>

                    <h4 for="">Estado</h4>
                    <div>
                        <label for="">Todas</label><input type="radio" v-model="status" id="todas" value="todas">
                        <label for="">Aprobadas</label><input type="radio" v-model="status" id="aprobadas" value="approved">
                        <label for="">Retiradas</label><input type="radio" v-model="status" id="retiradas" value="block">
                    </div>

                    <h4 for="">Turno</h4>
                    <div>
                        <label for="">Todas</label><input type="radio" v-model="turno" id="todas" value="todas">
                        <label for="">Mañana</label><input type="radio" v-model="turno" id="mañana" value="mañana">
                        <label for="">Tarde</label><input type="radio" v-model="turno" id="tarde" value="tarde">
                        <label for="">Noche</label><input type="radio" v-model="turno" id="noche" value="noche">
                    </div>
                    <button v-if="exportModelsStatus" @click="exportModels()">Exportar</button>
                    <button v-if="!exportModelsStatus"><a :href="export_link" @click="exportModelsStatus = true">Descargar Nomina</a></button>
                </div>
            </div>
        </b-modal>
        <div class="box-list">
            <center v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="200">
                <button @click="$refs.import_profiles_modal.show()">Importar Modelos</button>
                <h3>Lista modelos</h3>
                <button class="export" @click="$refs.export_profiles_modal.show()">Exportar Modelos</button>
                <input type="text" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                <table>
                    <thead>
                        <tr>
                            <th>Foto</th>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>Turno</th>
                            <th>Estado</th>
                            <th>Documento</th>
                            <th>Tipo de modelo</th>
                            <th>Perfil</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list" :key="index" :class="[{'approved': item.status === 'approved'}, {'no_assoc': item.status === 'no_assoc'}, {'pending': item.status === 'pending'}, {'block': item.status === 'block'}]">
                            <td><img :src="item.photo" alt=""></td>
                            <td>{{item.name}}</td>
                            <td>{{item.lastname}}</td>
                            <td>{{item.turno}}</td>
                            <td><select v-model="item.status" @change="changeStatusModel(item.id, item.status)">
                                <option v-for="(status, index) in statusList" :key="index" :value="status.name" v-if="status.name === 'pending' || status.name === 'approved' || status.name === 'block'" @change="changeStatus()">{{ status.name_show }}</option>
                            </select></td>
                            <td>{{item.document}}</td>
                            <td>{{item.model_type === true ? 'STUDIO' : 'SATELITE'}}</td>
                            <td><button @click="$router.push('/modelo/' + item.id + '/profile')">ver perfil</button></td>
                        </tr>
                    </tbody>
                </table>
            </center>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'
import Notify from '@/utils/Notification'

export default {
    name: 'lista',
    data() {
        return {
            list: [],
            limit: 40,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            searchValue: '',
            statusList: [],
            type: null,
            status: null,
            turno: null,
            exportModelsStatus: true,
            export_link: null
        }
    },
    watch: {
        searchValue: function() {
            if (this.searchValue === '') {
                this.list = []
                this.getAllModels()
            }
        }
    },
    beforeMount() {
        this.$root.$emit('changeList', this.$route.name)
    },
    methods: {
        exportModels() {
            API.exportProfiles({status: this.status, type: this.type, turno: this.turno})
                .then((res) => {
                    this.export_link = res.link
                    this.exportModelsStatus = false
                })
        },
        changeStatusModel(id, status) {
            API.changeStatus(status, id)
                .then(() => {

                })
        },
        callStatusList() {
            API.statusList()
                .then((res) => {
                    this.statusList = res
                })
        },
        importModels() {
            API.importProfiles(this.$refs.file_profiles.files[0])
                .then((res) => {
                    Notify('dirty', 'Se importaron las modelos faltantes')
                })
        },
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limit = 20
                this.offset = 0
                this.list = []
                this.searchModel()
            } else if (this.searchValue.length > 0) {
                this.limit = 20
                this.offset = 0
                this.list = []
                this.searchModel()
            }
        },
        onEnter () {
            this.searchModel()
        },
        searchModel() {
            this.modelSearch = false
            this.getAllModels()
        },
        priceFormat: function(item) {
            return Price(item)
        },
        getAllModels() {
            const limit = this.searchValue === '' ? this.limit : 'ALL'
            const offset = this.searchValue === '' ? this.offset : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.getAllModels(limit, offset, searchValueinitial)
                .then((res) => {
                    var clean = res.filter((arr, index, self) => index === self.findIndex((t) => (t.id === arr.id)))
                    if (this.searchValue !== '') {
                        this.list = clean
                    } else {
                        clean.map(item => { this.list.push(item) })
                        this.offset += this.limit
                        this.itemFlag = true
                    }
                })
        },
        loadMore() {
            if (this.searchValue !== '') {
                return
            }
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.list.length < this.offset / 4) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getAllModels()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        }
    },
    mounted() {
        this.getAllModels()
        this.callStatusList()
    }
}
</script>

<style scoped>
.lista {
    background-color: #cdcdcd;
    min-height: 78vh;
    padding: 20px;
}
.lista > .box-list {
    background: #585858;
    width: 100%;
    padding: 20px;
    height: 72vh;
    border-radius: 20px;
    border-style: outset;
}
.lista > .box-list > center {
    padding: 30px;
    overflow-y: auto;
    height: 70vh;
    position: relative;
}
.lista > .box-list > center > button {
    background-color: #e0b059;
    color: #fff;
    min-width: 50px;
    height: auto;
    border-radius: 30px;
    width: 200px;
    padding: 10px;
    position: absolute;
    right: 20px;
    margin-top: -20px
}
.lista > .box-list > center > button.export {
    background-color: #e0b059;
    color: #fff;
    min-width: 50px;
    height: auto;
    border-radius: 30px;
    width: 200px;
    padding: 10px;
    position: absolute;
    left: 20px;
    margin-top: -60px
}
.lista > .box-list > center > input {
    width: 100%;
    height: 40px;
    border-radius: 20px;
    text-align: center;
}
.lista > .box-list > center > table {
    margin-top: 30px;
    border-radius: 20px;

}
.lista > .box-list > center > table > thead > tr {
    text-align: center;
    color: #fff;
    font-weight: bold;
    background-color: #3a88b5;
}
.lista > .box-list > center > table > thead > tr > th {
    padding: 30px;
    border-style: double;
}
.lista > .box-list > center > table > tbody > tr {
    text-align: center;
    color: #fff;
    font-weight: bold;
}
.lista > .box-list > center > table > tbody > .approved {
    background-color: #3f7a3f;
}
.lista > .box-list > center > table > tbody > .block {
    background-color: #bb2124;
}
.lista > .box-list > center > table > tbody > .pending {
    background-color: #f0ad4e;
}
.lista > .box-list > center > table > tbody > tr > td {
    padding: 10px;
    border-style: double;
}
.lista > .box-list > center > table > tbody > tr > td > img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 50%;
}
.lista > .box-list > center > table > tbody > tr > td > button {
   background-color: #e0b059;
    color: #fff;
    min-width: 50px;
    height: auto;
    border-radius: 30px;
    width: 200px;
    padding: 10px;
}
.lista > .box-list > center > h3 {
    color:#fff
}

.info-wrapper > div {
    display: grid;
    align-items: center;
    justify-items: center;
}

.info-wrapper > h3 {
    margin: 50px;
}

.info-wrapper > div > button {
    background-color: #e0b059;
    color: #fff;
    min-width: 50px;
    height: auto;
    border-radius: 30px;
    width: 200px;
    padding: 10px;
    margin: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/Modelos/Listas/Alllist.vue